import { render, staticRenderFns } from "./TheForgotPasswordModal.vue?vue&type=template&id=2a20dfbf"
import script from "./TheForgotPasswordModal.vue?vue&type=script&lang=js"
export * from "./TheForgotPasswordModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports